export default {
  general: {
    appTitle: 'installfest',
  },
  navigation: {
    labels: {
      about: 'O semináři',
      lectures: 'Přednášky',
      workshops: 'Workshopy',
      venue: 'Kontakt',
      sponsors: 'Partneři',
      information: 'Informace ke konferenci',
      stands: 'Stánky',
      reportProblem: 'Nahlásit problem',
    },
  },
  pages: {
    about: {
      text: require('./about/text').default,
    },
    lectures: {
      text: require('./lectures/text').default,
    },
    workshops: {
      text: require('./workshops/text').default,
    },
    sponsors: {
      sections: [require('./sponsors/partners').default],
    },
    venue: {
      mapImage: require('./resources/map-osm.png'),
      mapLink:
        'http://www.openstreetmap.org/#map=18/50.07667/14.41789&layers=N',
      text: require('./venue/text').default,
      text2: require('./venue/text2').default,
    },
    information: {
      text: require('./information/text').default,
    },
    stands: {
      text: require('./stands/text').default,
    },
    reportProblem: {},
  },
  data: {
    tracks: require('./data/tracks').default,
    sessions: require('./data/sessions').default,
    presentations: require('./data/presentations').default,
    presenters: require('./data/presenters').default,
  },
  addons: {
    feedback: require('./addons/feedback').default,
    socialShare: require('./addons/socialShare').default,
  },
  intl: {
    preferredLocales: ['CZ-cz', 'SK-sk', 'EN-en'],
    messages: require('../../intl/messages/sk').default,
  },
  // theme will be deep-merged with default theme
  // see theme properties: http://www.material-ui.com/#/customization/themes
  // `custom` key contains addintional theme keys (see default theme in `theme.js`)
  theme: {
    palette: {
      primary1Color: 'black',
    },
    custom: {
      colors: {
        backgroundColor: 'white',
      },
    },
    appBar: {
      color: 'black',
    },
    tabs: {
      backgroundColor: 'black',
    },
    menuItem: {
      selectedTextColor: 'darkred',
    },
  },
}



// WEBPACK FOOTER //
// ./src/content/installfest/index.js